import api from './api';

export const getGateGroups = (params) => api.get('/v1/gate-groups', { params });
export const getGateGroup = (id) => api.get(`/v1/gate-groups/${id}`);
export const createGateGroup = (data) => api.post('/v1/gate-groups', data);
export const updateGateGroup = (id, data) => api.put(`/v1/gate-groups/${id}`, data);
export const deleteGateGroup = (id) => api.delete(`/v1/gate-groups/${id}`);
export const batchDeleteGateGroups = (ids) => api.post('/v1/gate-groups/batch-delete', { ids });
export const getGateGroupGates = (id) => api.get(`/v1/gate-groups/${id}/gates`);
export const addGatesToGroup = (id, gateIds) => api.post(`/v1/gate-groups/${id}/gates`, { gateIds });
export const removeGateFromGroup = (id, gateId) => api.delete(`/v1/gate-groups/${id}/gates/${gateId}`);
